import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export default function PrivacyPage() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = "Privacy Policy | L+TV TÉLÉVISION";
  }, []);

  return (
    <div className="pt-20">
      <div className="bg-primary-900 py-8">
        <div className="ltv-container">
          <h1 className="text-2xl md:text-3xl font-bold text-white">{t("legal.privacy.title")}</h1>
        </div>
      </div>
      <div className="ltv-container py-8 md:py-12">
        <div className="max-w-3xl mx-auto prose prose-sm max-w-none text-foreground-700">
          <h2 className="text-lg font-bold text-foreground-900 mb-3">{t("legal.privacy.sec1")}</h2>
          <p className="mb-4">{t("legal.privacy.sec1p")}</p>
          <h2 className="text-lg font-bold text-foreground-900 mb-3">{t("legal.privacy.sec2")}</h2>
          <p className="mb-4">{t("legal.privacy.sec2p")}</p>
          <h2 className="text-lg font-bold text-foreground-900 mb-3">{t("legal.privacy.sec3")}</h2>
          <p className="mb-4">{t("legal.privacy.sec3p")}</p>
          <h2 className="text-lg font-bold text-foreground-900 mb-3">{t("legal.privacy.sec4")}</h2>
          <p className="mb-4">{t("legal.privacy.sec4p")}</p>
          <h2 className="text-lg font-bold text-foreground-900 mb-3">{t("legal.privacy.sec5")}</h2>
          <p className="mb-4">{t("legal.privacy.sec5p")}</p>
        </div>
      </div>
    </div>
  );
}